import React, { useEffect, useState } from 'react'
import companyServices from '../../company/companyServices';
import { Email, Phone, Business, ReceiptLong } from '@mui/icons-material';
import voucherServices from '../voucherServices';
import { useAppData } from '../../../../../../context/AppDataContext';
import partyServices from '../../party/partyServices';
import SelectPartyAddress from '../../party/components/SelectPartyAddress';

function PurchaseVoucherHeader({ voucherDetails, companyDetails, setCompanyDetails, partyDetails, setPartyDetails, callBack }) {

    const [partyLoading, setPartyLoadingStatus] = useState(false);
    const [companyLoading, setCompanyLoadingStatus] = useState(false);
    const { getMasterLabel } = useAppData();

    const getPartyDetails = () => {
        setPartyLoadingStatus(true);
        setPartyDetails(null);
        partyServices.getById(voucherDetails.partyId).then(res => {
            setPartyDetails(res.data);
        }).catch(error => {
            console.error(error);
        }).finally(() => {
            setPartyLoadingStatus(false);
        })
    }

    const getCompanyDetails = () => {
        setCompanyLoadingStatus(true);
        companyServices.getById(voucherDetails.companyId).then(res => {
            setCompanyDetails(res.data);
        }).catch(error => {
            console.error(error);
        }).finally(() => {
            setCompanyLoadingStatus(false);
        })
    }

    useEffect(() => {
        if (voucherDetails) {
            getPartyDetails();
            getCompanyDetails();
        }
    }, [voucherDetails])

    const updateShippingAddress = (partyAddress) =>{
        let payload = {
            id:voucherDetails.id,
            shippingAddress : partyAddress.addressString,
        }
        voucherServices.save(payload).then(res=>{
            callBack();
        })
    }

    const updateBillingAddress = (partyAddress) =>{
        let payload = {
            id:voucherDetails.id,
            billingAddress : partyAddress.addressString,
            supplyState:partyAddress.address.supplyState,
        }
        voucherServices.save(payload).then(res=>{
            callBack();
        })
    }

    return (
        voucherDetails && companyDetails && partyDetails &&
        <table className='table table-sm table-bordered mb-0' style={{ fontSize: 12, border: '2px solid #444' }}>
            <thead>
                {/* Header Title Section - Styled differently for Purchase */}
                <tr style={{ backgroundColor: '#f8f9fa' }}>
                    <th className='text-center py-2' colSpan={2}>
                        <h5 className='mb-0 text-uppercase fw-bold' style={{ letterSpacing: '1px' }}>
                            <ReceiptLong className='me-2' />
                            <span>
                                {voucherDetails.voucherType === "Purchase" && "Purchase"}
                                {voucherDetails.voucherType === "CreditNote" && "Credit Note"}
                                {voucherDetails.voucherType === "ChallanIn" && "GRN"}
                            </span>
                            <span className='ms-2'>Voucher</span>
                            
                        </h5>
                    </th>
                </tr>
                <tr>
                    {/* Left Side: Your Company Info (The Receiver) */}
                    <td width={"60%"} className='align-top py-0'>
                        {/* <div className='fw-bold text-muted small mb-1 text-uppercase'>Bill To / Deliver To:</div> */}
                        <div className="d-flex">
                            <div className='me-3'>
                                {companyDetails.logo && <img src={companyDetails.logo} style={{ maxHeight: "0.8in", maxWidth: "1.5in" }} className='bg-light border p-1' alt="logo" />}
                            </div>
                            <div>
                                <div className='fw-bold' style={{ fontSize: 14 }}>{companyDetails.companyName}</div>
                                <div>{companyDetails.address}</div>
                                <div>{companyDetails.city}, {getMasterLabel("indian-state", companyDetails.state)} - {companyDetails.zip}</div>
                                <div className='mt-1'>
                                    <span className='fw-bold'>GSTIN: </span>{companyDetails.gst.toUpperCase()}
                                </div>
                                <div className='small text-muted'>
                                    <Email style={{ fontSize: 12 }} /> {companyDetails.email} | <Phone style={{ fontSize: 12 }} /> {companyDetails.phone}
                                </div>
                            </div>
                        </div>
                    </td>

                    {/* Right Side: Voucher/Reference Details */}
                    <td className='p-0'>
                        <table className='table table-sm mb-0 table-borderless'>
                            <tbody>
                                <tr className='border-bottom'>
                                    <td className='fw-bold bg-light' width="50%">
                                        {voucherDetails.voucherType === "Purchase" && "Purchase #"}
                                        {voucherDetails.voucherType === "CreditNote" && "Credit Note #"}
                                        {voucherDetails.voucherType === "ChallanIn" && "GRN #"}
                                    </td>
                                    <td className='ps-2'>{voucherDetails.voucherNo}</td>
                                </tr>
                                <tr className='border-bottom'>
                                    <td className='fw-bold bg-light'>Voucher Date:</td>
                                    <td className='ps-2'>{voucherDetails.voucherDate}</td>
                                </tr>
                                <tr className='border-bottom'>
                                    <td className='fw-bold bg-light'>Supplier Inv No:</td>
                                    <td className='ps-2 fw-bold text-primary'>{voucherDetails.refNo || 'N/A'}</td>
                                </tr>
                                {/*
                                <tr>
                                    <td className='fw-bold bg-light'>Payment Terms:</td>
                                    <td className='ps-2'>{voucherDetails.paymentDueDate || 'Immediate'}</td>
                                </tr>
                                */}
                            </tbody>
                        </table>
                    </td>
                </tr>

                {/* Party Section: The Supplier */}
                <tr>
                    <td colSpan={2} className='p-0'>
                        <div className="d-flex">
                            {/* Supplier Billing Address */}
                            <div className="px-3 border-end" style={{ width: "50%" }}>
                                <div className='d-flex justify-content-between align-items-start hover-container'>
                                    <div className='fw-bold text-muted small text-uppercase mb-0 '><Business fontSize='inherit' /> Supplier (Bill From)</div>
                                    {voucherDetails.status === 1 &&
                                        <SelectPartyAddress 
                                            partyId={partyDetails.id} 
                                            callBack={updateBillingAddress} 
                                            address={voucherDetails.billingAddress} 
                                            caption="Supplier Address"
                                        />
                                    }
                                </div>
                                {voucherDetails.billingAddress ? (
                                    <div className='hover-container'>
                                        <div className='fw-bold'>{partyDetails.displayName}</div>
                                        <div style={{ whiteSpace: 'pre-line' }}>{voucherDetails.billingAddress}</div>
                                        {/* <div>{voucherDetails.billingAddress.city}, {getMasterLabel("indian-state", voucherDetails.billingAddress.state)} - {voucherDetails.billingAddress.zip}</div> */}
                                        {/*<div className='fw-bold mt-1'>GSTIN: {voucherDetails.partyGstin?.toUpperCase() || 'URD'}</div>*/}
                                        {voucherDetails.partyGstin !== "" && voucherDetails.partyGstin !== null &&<div className='fw-bold mt-1'>GST # {voucherDetails.partyGstin.toUpperCase()}</div> }
                                        {/* <div className='fw-bold mt-1'>Supply State : {getMasterLabel("indian-state", voucherDetails.supplyState)}</div> */}
                                    </div>
                                ) : (
                                    <div className='text-danger'>Please Select Supplier Address</div>
                                )}
                            </div>

                            {voucherDetails.billingAddress &&
                                <div className="px-3" style={{ width: "50%" }}>
                                    <div className='d-flex justify-content-between align-items-start hover-container'>
                                        <div className='fw-bold text-muted small text-uppercase mb-0'>Dispatch From</div>
                                        {voucherDetails.status === 1 &&
                                            <SelectPartyAddress 
                                                partyId={partyDetails.id} 
                                                callBack={updateShippingAddress} 
                                                address={voucherDetails.shippingAddress} 
                                                caption="Dispatch Location"
                                            />
                                        }
                                    </div>
                                    {voucherDetails.shippingAddress ? (
                                        <div className='hover-container'>
                                            <div>{voucherDetails.shippingAddress.contactPerson}</div>
                                            <div style={{ whiteSpace: 'pre-line' }}>{voucherDetails.shippingAddress}</div>
                                            {/* <div>{voucherDetails.shippingAddress.city}, {getMasterLabel("indian-state", voucherDetails.shippingAddress.state)} - {voucherDetails.shippingAddress.zip}</div> */}
                                        </div>
                                    ) : (
                                        <div className='text-muted small'>Same as Billing Address</div>
                                    )}
                                </div>
                            }
                        </div>
                    </td>
                </tr>
            </thead>
        </table>
    )
}

export default PurchaseVoucherHeader;